var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// React
import React from 'react';
// Material ui
import TextField from '@material-ui/core/TextField/TextField';
// Date and time components
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from '@material-ui/pickers';
import moment from 'moment';
import 'moment/locale/fr';
import { InputType } from '../../models/FormTypes';
import { getFormattedDate } from "./inputForm.core";
// Utils
import { debounce } from '../../helpers/utils';
/**
 * Input form component
 * @param props - Input form properties
 */
var InputForm = function (props) {
    var initialValue = props.initialValue, onChange = props.onChange, onUnMount = props.onUnMount, visible = props.visible, reset = props.reset, otherProps = __rest(props
    /** Component properties */
    , ["initialValue", "onChange", "onUnMount", "visible", "reset"]);
    /** Component properties */
    var label = props.label, name = props.name, type = props.type, error = props.error, helperText = props.helperText;
    /** Component state */
    var _a = React.useState(initialValue), value = _a[0], setValue = _a[1];
    React.useEffect(function () {
        return function () {
            if (onUnMount) {
                onUnMount();
            }
        };
    }, [onUnMount]);
    React.useEffect(function () {
        if (reset) {
            setValue('');
        }
    }, [reset]);
    /**
     * Handle input date text change
     * @param change
     */
    var handleChangeDate = function (change) {
        var momentValue = moment(change).format('YYYY-MM-DD');
        if (momentValue !== value) {
            onChange('keyValue', [name, momentValue]);
        }
        setValue(momentValue);
    };
    var handleChangeText = function (e) {
        e.persist();
        setValue(e.target.value);
        debounce(function () {
            onChange('event', e);
        })();
    };
    // Mount effect
    React.useEffect(function () {
        moment.locale('fr');
    }, []);
    if (!visible) {
        return null;
    }
    // Render
    if (type === InputType.date) {
        return React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils, locale: 'fr', libInstance: moment },
            React.createElement(KeyboardDatePicker, { cancelLabel: "Annuler", style: { width: '100%' }, label: label, value: getFormattedDate(value), format: "DD/MM/YYYY", placeholder: "31/08/2002", maxDate: Date.now(), onChange: handleChangeDate, animateYearScrolling: false, disableFuture: true, allowKeyboardControl: true, openTo: 'year', error: error, helperText: helperText, required: otherProps.required }));
    }
    return React.createElement(TextField, __assign({}, otherProps, { onChange: handleChangeText, value: value, margin: "normal" }));
};
export default React.memo(InputForm);
//# sourceMappingURL=index.js.map